import { persistStepsMiddleware } from './persistStepsMiddleware';

export default [persistStepsMiddleware];
